import styled from 'styled-components';

const Company = styled('div')({
  display: 'flex',
  fontWeight: 800,
  alignItems: 'center',
  justifyContent: 'flex-start',
  fontSize: '30px',
});

export default Company;
